import axios from "axios";
import toast from 'react-hot-toast';
import config from "src/apiServices/appConfig";

// Get the base URL from environment variable
const baseURL = config.BASE_URL
console.log(baseURL)

export const axiosInstance = axios.create({
  baseURL,
  timeout: 30000, // 30 seconds
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true, 
});


axiosInstance.interceptors.request.use(
  (config) => {
    // Get token from localStorage or wherever you store it
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  
  (error) => {
    if (error.response) {
      console.log("comes in the eerr page", error.response);
      // Handle specific error codes
      switch (error.response.status) {
        case 401:
          // Clear all auth related data from localStorage
          localStorage.removeItem("token");
          localStorage.removeItem("access_token");
          localStorage.removeItem("refresh_token");
          localStorage.removeItem("current_user");
          
          // Show session expired message
          toast.error('Session expired. Please login again.');
          
          // Handle unauthorized by redirecting to login
          const currentPath = window.location.pathname;
          const searchParams = new URLSearchParams({ returnTo: currentPath }).toString();
          window.location.href = `/auth/jwt/login?${searchParams}`;
          break;
        case 403:
          // Handle forbidden
          toast.error(error.response?.data?.message || 'Operation not permitted');
          break;
        case 404:
          // Handle not found
          break;
        default:
          // Handle other errors
          break;
      }
    }
    return Promise.reject(error);
  }
);
